module.exports = __webpack_public_path__ + "img/viz-sectores.13dcd8d8.png";